import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
import useApi from "../../Hooks/useApi";
import Loader from "../../components/Loader";
import {
  commaSeparator,
  formatDateToFullMonth,
  statusCode200,
} from "../../helpers";
import HeaderList from "../HeaderList";
import ReportFooter from "../ReportFooter";
import ReportHeader from "../ReportHeader";
import classes from "./IncomeExpenseReport.module.css";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { use } from "react";
const formattedDateInWords = (inputDate) =>
  moment(inputDate).format("D MMM YYYY");

const convertDate = (dateStr) => {
  return moment(dateStr).format("DD-MM-YYYY");
};
function IncomeExpenseReport({
  title = "Income And Expense Report",
  period,
  communityAddress,
  showSurplusDeficit = true,
  onBack,
  data,
}) {
  const params = useParams();
  const navigate = useNavigate();
  const { communityName, communitiesList, communityId } = useSelector(
    (state) => state?.authReducer
  );
  const [reports, setReports] = useState(null);
  const [loading, setLoading] = useState(true);

  const findCommunity = communitiesList?.find(
    (community) => community?.communityId == communityId
  );
  let totalIncomeReport = 0;
  let totalExpenseReport = 0;
  //check for total income report
  if (reports?.incomeDetail?.length > 0)
    totalIncomeReport = reports?.incomeDetail?.reduce(
      (sum, item) => sum + item.amount,
      0
    );
  //check for total expense report
  if (reports?.expenseDetail?.length > 0)
    totalExpenseReport = reports?.expenseDetail?.reduce(
      (sum, item) => sum + item.amount,
      0
    );
  const surplusDeficit = totalIncomeReport - totalExpenseReport;

  const api = useApi();
  const printRef = useRef(null);
  // Replace the pageStyle in your handlePrint with this updated version:

  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: `Income_Expense_Report`,
    pageStyle: `
    @page { 
      size: A4; 
      margin: 15mm 10mm 15mm 10mm; 
      
      @top-center {
        color: #fff;
        content: "";
      }
      @bottom-center {
        color: #fff;
        content: "";
      }
    }
    
@media print {
  .print-wrapper {
    display: flex !important;
    flex-direction: column !important;
    width: 100% !important;
    height: 100% !important;       /* take full page height */
    min-height: 100vh !important;  /* at least one page */
    background: white !important;
  }

  .child-div {
    display:flex !important;
    flex-direction: column !important;
    flex:1;
    height: 100% !important; /* allow body to stretch */
  }

  .report-footer {
    display: table-footer-group !important;
    page-break-inside: avoid !important;
    page-break-before: avoid !important;
    margin-top: auto !important;
    padding-top: 20px !important;
    background: white !important;
  }

  table thead {
    display: table-header-group !important;
  }

  table tfoot {
    display: table-footer-group !important;
  }
}


  `,
  });

  const headerDetails = [
    { id: "2", label: "Community Name:", value: communityName },
    {
      id: "3",
      label: "Community Address:",
      value: findCommunity?.communityAddress,
    },
    {
      id: "2",
      label: "Report Period:",
      value: `${formattedDateInWords(data?.fromDate)} to ${formattedDateInWords(
        data?.toDate
      )}`,
    },
    {
      id: "3",
      label: "Print Date:",
      value: moment().format("DD MMM YYYY hh:mm A"),
    },
  ];

  const getIncomeExpenseReport = async (params) => {
    setLoading(true);
    const response = await api.getIncomeExpenseReport(params);
    if (statusCode200(response)) {
      setReports(response?.data?.body);
    } else {
      toast.error(response?.data?.headers?.msg);
    }
    setLoading(false);
  };

  useEffect(() => {
    getIncomeExpenseReport({
      fromDate: convertDate(params?.fromDate),
      toDate: convertDate(params?.toDate),
      accountCode: null,
    });
  }, []);

  const backHandler = () => {
    navigate("/reports");
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <ReportHeader onBack={backHandler} handlePrint={handlePrint} />

          <div
            className={[classes.container, "container"].join(" ")}
            style={{ background: "white" }}
          >
            <div
              className={[classes.card, "print-wrapper"].join(" ")}
              ref={printRef}
              style={{ background: "white", backgroundImage: "none" }}
            >
              <div
                className={[classes.cardContent, "child-div"].join(" ")}
                style={{ background: "white", backgroundImage: "none" }}
              >
                <div
                  className="content-area"
                  style={{ background: "white", backgroundImage: "none" }}
                >
                  {/* Header */}
                  <div
                    className={classes.headerContainer}
                    style={{ background: "white", backgroundImage: "none" }}
                  >
                    <div
                      className={[classes.headerButton, "header-title"].join(
                        " "
                      )}
                      style={{ background: "white", backgroundImage: "none" }}
                    >
                      {title}
                    </div>
                  </div>

                  {/* Report Details */}
                  <div
                    className={classes.reportDetails}
                    style={{ background: "white", backgroundImage: "none" }}
                  >
                    <HeaderList data={headerDetails} />
                  </div>

                  {/* Main Financial Table */}
                  <table
                    className={classes.financialTable}
                    style={{ background: "white", backgroundImage: "none" }}
                  >
                    <tbody
                      style={{ background: "white", backgroundImage: "none" }}
                    >
                      {/* Income Section */}
                      {reports?.incomeDetail?.length > 0 && (
                        <>
                          <tr
                            className={classes.sectionRow}
                            style={{
                              background: "white",
                              backgroundImage: "none",
                            }}
                          >
                            <td
                              className={classes.sectionHeading}
                              style={{
                                background: "white",
                                backgroundImage: "none",
                                color: "#6b7280;",
                              }}
                            >
                              Income
                            </td>
                            <td
                              className={classes.sectionHeading}
                              style={{
                                background: "white",
                                backgroundImage: "none",
                              }}
                            >
                              {""}
                            </td>
                          </tr>
                          {reports?.incomeDetail?.map((item, index) => (
                            <tr
                              key={`income-${index}`}
                              className={classes.itemRow}
                              style={{
                                background: "white",
                                backgroundImage: "none",
                              }}
                            >
                              <td
                                className={classes.itemCategory}
                                style={{
                                  background: "white",
                                  backgroundImage: "none",
                                }}
                              >
                                <span className={[classes.ml].join(" ")}>
                                  {item.category}
                                </span>
                              </td>
                              <td
                                className={classes.itemAmount}
                                style={{
                                  background: "white",
                                  backgroundImage: "none",
                                }}
                              >
                                {commaSeparator(item.amount)}
                              </td>
                            </tr>
                          ))}
                          <tr
                            className={classes.totalRow}
                            style={{
                              background: "white",
                              backgroundImage: "none",
                            }}
                          >
                            <td
                              className={classes.totalCategory}
                              style={{
                                background: "white",
                                backgroundImage: "none",
                              }}
                            >
                              Total Income
                            </td>
                            <td
                              className={classes.totalAmount}
                              style={{
                                background: "white",
                                backgroundImage: "none",
                              }}
                            >
                              {commaSeparator(totalIncomeReport)}
                            </td>
                          </tr>
                        </>
                      )}

                      {/* Expense Section */}

                      <>
                        <tr
                          className={classes.sectionRow}
                          style={{
                            background: "white",
                            backgroundImage: "none",
                          }}
                        >
                          <td
                            className={classes.sectionHeading}
                            style={{
                              background: "white",
                              backgroundImage: "none",
                            }}
                          >
                            Expense
                          </td>
                          <td
                            className={classes.sectionHeading}
                            style={{
                              background: "white",
                              backgroundImage: "none",
                            }}
                          >
                            {""}
                          </td>
                        </tr>
                        {reports?.expenseDetail?.map((item, index) => (
                          <tr
                            key={`expense-${index}`}
                            className={classes.itemRow}
                            style={{
                              background: "white",
                              backgroundImage: "none",
                            }}
                          >
                            <td
                              className={classes.itemCategory}
                              style={{
                                background: "white",
                                backgroundImage: "none",
                              }}
                            >
                              <span className={classes.ml}>
                                {`${item.category}${
                                  item?.description
                                    ? ` - ${item.description}`
                                    : ""
                                }`}
                              </span>
                            </td>
                            <td
                              className={`${classes.itemAmount} ${classes.itemAmountExpense}`}
                              style={{
                                background: "white",
                                backgroundImage: "none",
                              }}
                            >
                              {`(${commaSeparator(item?.amount, true)})`}
                            </td>
                          </tr>
                        ))}
                        <tr
                          className={classes.totalRow}
                          style={{
                            background: "white",
                            backgroundImage: "none",
                          }}
                        >
                          <td
                            className={classes.totalCategory}
                            style={{
                              background: "white",
                              backgroundImage: "none",
                            }}
                          >
                            Total Expenses
                          </td>
                          <td
                            className={`${classes.totalAmount} ${classes.totalAmountExpense}`}
                            style={{
                              background: "white",
                              backgroundImage: "none",
                            }}
                          >
                            {`(${commaSeparator(totalExpenseReport, true)})`}
                          </td>
                        </tr>
                      </>

                      {/* Surplus/Deficit */}
                      {showSurplusDeficit && (
                        <tr
                          className={classes.surplusDeficitRow}
                          style={{
                            background: "white",
                            backgroundImage: "none",
                          }}
                        >
                          <td
                            className={classes.surplusDeficitCategory}
                            style={{
                              background: "white",
                              backgroundImage: "none",
                            }}
                          >
                            Surplus/Deficit
                          </td>
                          <td
                            className={[
                              classes.surplusDeficitAmount,
                              surplusDeficit < 0 && classes.red,
                            ].join(" ")}
                            style={{
                              background: "white",
                              backgroundImage: "none",
                            }}
                          >
                            {surplusDeficit < 0
                              ? `(${commaSeparator(Math.abs(surplusDeficit))})`
                              : commaSeparator(surplusDeficit)}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Footer - Now properly positioned */}
                <div
                  className="report-footer"
                  style={{
                    background: "white",
                    backgroundImage: "none",
                    pageBreakInside: "avoid",
                    marginTop: "auto",
                    padding: "0",
                  }}
                >
                  <ReportFooter className={classes.footer} />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default IncomeExpenseReport;
